module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "support"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Support"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Open a support ticket and our teams will help you'),
      expression: "'Open a support ticket and our teams will help you'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), (_vm.supportTicketsAvailable) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('h4', {
    staticClass: "support-legend-title"
  }, [_vm._v("Department Contact")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "clearfix support-box",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitTicket()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 nopad col-md-6 left"
  }, [_c('label', [_vm._v("Select Department:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.department),
      expression: "department"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.department = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.tag = null
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "technical"
    }
  }, [_vm._v("Computer Support / Software Licensing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bugs"
    }
  }, [_vm._v("Portal Bugs")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 nopad right"
  }, [_c('label', [_vm._v("Ticket Urgency:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priority),
      expression: "priority"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.priority = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.priorities), function(priority) {
    return _c('option', {
      domProps: {
        "value": priority.level
      }
    }, [_vm._v(_vm._s(priority.label))])
  }))]), _vm._v(" "), (_vm.department === 'course') ? _c('div', [_c('p', {
    staticClass: "col-xs-12"
  }, [_vm._v("For any academic, curriculum or course questions please post in your group chat channel or message your supervisor, alternatively you can post in the general chat channels and forums for support from fellow students.")])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12 nopad"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.message
    },
    on: {
      "change": _vm.updateMessage
    }
  })], 1), _vm._v(" "), _vm._m(2)])])])]) : _c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("Support will become active at noon Pacific Time on the Tuesday before your first term starts.")])])]), _vm._v(" "), (_vm.tickets) ? _c('div', {
    staticClass: "tickets"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Your Support Tickets"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Tickets you\'ve opened for help and support'),
      expression: "'Tickets you\\'ve opened for help and support'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.tickets), function(ticket, index) {
    return _c('li', {
      staticClass: "list-group-item ticket-wrapper",
      attrs: {
        "id": 'ticket_' + ticket.id
      }
    }, [_c('div', {
      staticClass: "content ticket-info row clearfix",
      on: {
        "click": function($event) {
          _vm.openTicket(index)
        }
      }
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [(_vm.selectedTicket !== index) ? _c('p', [_vm._v(_vm._s(_vm._f("truncate")(_vm._f("stripTags")(ticket.body), 2700)))]) : _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linkify(ticket.body))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h5', [_vm._v("Department: " + _vm._s(_vm._f("capitalize")(ticket.department)))]), _vm._v(" "), (ticket.department === 'course' && ticket.tags.length > 0 && ticket.tags[0]) ? _c('div', {
      staticClass: "indent"
    }, [_vm._v("\n                                    (" + _vm._s(_vm._f("formatCourseTags")(ticket.tags)) + ")\n                                ")]) : _vm._e(), _vm._v(" "), (ticket.agent) ? _c('div', [_c('h5', {
      staticClass: "representative"
    }, [_vm._v("Representative:")]), _vm._v(" "), _c('div', {
      staticClass: "indent"
    }, [_vm._v(_vm._s(ticket.agent.firstName) + " " + _vm._s(ticket.agent.lastName))])]) : _vm._e(), _vm._v(" "), (ticket.resolved) ? _c('div', {
      staticClass: "resolved"
    }, [_vm._v("Resolved")]) : _vm._e()])]), _vm._v(" "), (_vm.selectedTicket === index) ? _c('div', [(ticket.replies.length > 0) ? _c('ul', {
      staticClass: "list-group replies"
    }, _vm._l((ticket.replies), function(reply) {
      return _c('li', {
        staticClass: "list-group-item",
        class: {
          'from-me': _vm.isFromMe(reply.from) === true
        }
      }, [_c('div', {
        staticClass: "reply-body",
        domProps: {
          "innerHTML": _vm._s(_vm.$options.filters.linkify(reply.body))
        }
      })])
    })) : _vm._e(), _vm._v(" "), _c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.replyToTicket(index)
        }
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('vue-html5-editor', {
      attrs: {
        "content": ticket.reply
      },
      on: {
        "change": _vm.updateReply
      }
    })], 1), _vm._v(" "), _vm._m(3, true)])]) : _vm._e()])
  }))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8 support-ledgend nopad"
  }, [_c('p', [_c('strong', [_vm._v("Admissions")]), _c('br'), _vm._v("\n                    For questions about applying for another Think Tank program please email "), _c('a', {
    attrs: {
      "href": "mailto:admissions@tttc.ca"
    }
  }, [_vm._v("admissions@tttc.ca")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Program Management/Academics")]), _c('br'), _vm._v("\n                    For questions about class schedules, curriculum, lessons files, resources, grades or general academic support please email "), _c('a', {
    attrs: {
      "href": "mailto:programmanagement@tttc.ca"
    }
  }, [_vm._v("programmanagement@tttc.ca")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Career Success")]), _c('br'), _vm._v("\n                    For help with your job hunt and other post-graduation support please email "), _c('a', {
    attrs: {
      "href": "mailto:careerdev@tttc.ca"
    }
  }, [_vm._v("careerdev@tttc.ca")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Financial / Tuition / Payments")]), _c('br'), _vm._v("\n                    For any assistance with tuition payments, financial aid etc please email "), _c('a', {
    attrs: {
      "href": "mailto:accounting@tttc.ca"
    }
  }, [_vm._v("accounting@tttc.ca")])]), _vm._v(" "), _c('h4', {
    staticClass: "support-legend-title secondary"
  }, [_vm._v("Technical Support (Software) & Portal Bugs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8 support-ledgend nopad"
  }, [_c('div', {}, [_c('p', [_c('strong', [_vm._v("Computer Support / Software Licensing")]), _c('br'), _vm._v("Problems with installing software? Looking for recommended hardware specs? Something not working in Windows? Create a ticket today!\n                    "), _c('br'), _c('br'), _vm._v("For any software specific questions, \"UVs won't unwrap in Maya\" for example, please post in your group chat channel or message your supervisor.")])]), _vm._v(" "), _c('div', {}, [_c('p', [_c('strong', [_vm._v("Portal Bugs")]), _c('br'), _vm._v("\n                        Experiencing a Portal / Chat issue that's hampering your learning experience? Let us know ASAP and create a ticket!\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("* Responses can take 24-36 business hours. Please keep in mind, we adopt normal business hours (9-5 Mon-Fri, Canadian holidays are also observed) and will answer to the best of our abilities within working hours (PST).")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 text-right"
  }, [_vm._v("Note: you can reply to resolved tickets to reopen them.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4456a215!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support.vue
// module id = 2010
// module chunks = 2